import { useContext } from 'react'

import { UploadContext } from './UploadContext'

export function useUpload() {
    const upload = useContext(UploadContext)
    if (!upload) throw new Error('useUpload requires UploadProvider')

    return upload
}
